import Vue from "vue";
import { ActionTree, MutationTree, GetterTree } from "vuex";
import { RootState } from "@/store/types";
import { ServerResult } from "@/core/http/server_result";
import moment from "moment";
import { QueryBuilder } from "@/core/uql";
import cloneDeep from "lodash/cloneDeep";
import numeral from "numeral";
import {
  DEAL_LINE_KG_DECIMALS,
  ceilContainersFromKg,
} from "./ceilContainersFromKg";

interface DealProductsState {
  loaded: boolean;
  loading: boolean;
  fatalError: boolean;

  documentId: any;
  clientId: any;

  // productList: any[];
  // productVariantList: any[];
  prefereds: any;
  relatedProductsList: any[];

  targetForDelete: any[];
  // inWorkStatus: any;
  // formationStatus: any;
  // products: any[];
  remains: any[];
}

const state: DealProductsState = {
  loading: false,
  loaded: false,
  fatalError: false,

  documentId: null,
  clientId: null,

  // productList: [],
  // productVariantList: [],
  prefereds: [],
  relatedProductsList: [],

  targetForDelete: [],
  // products: [],
  remains: [],
};

const initState: any = cloneDeep(state);

const PL_RELAED_PRODUCTS_LIST = "PL_RELAED_PRODUCTS_LIST";
const PL_PRODUCT_PREFEREDS = "PL_PRODUCT_PREFEREDS";

function getBasketItem(state: DealProductsState, saved: any) {
  console.log("saved", saved);
  if (saved) {
    return {
      id: saved.id,

      product_id: saved.product_id,
      product_container_id: saved.product_container_id,

      product_container: {
        id: saved.product_container_id,
        price: saved.product_container_price,
        weight: saved.product_container_weight,
        price_per_kg: saved.product_container_price_per_kg,
        label: saved.product_container_name,
      },
      product: {
        id: saved.product_id,
        label: saved.product_name,
      },

      // @ts-ignore
      unit_quantity: parseFloat(
        `${saved.container_quantity * saved.product_container_weight}`,
      ).toFixed(DEAL_LINE_KG_DECIMALS),

      container_quantity: saved.container_quantity,
      container_price: saved.container_price,

      container_weight: saved.container_weight,

      is_sample: saved.product_container_is_sample,
      free_product_type_id: saved.free_product_type_id,

      notes: saved.notes,
      approve_comment: saved.approve_comment,
      sample_date: saved.sample_date
        ? moment(saved.sample_date).toDate()
        : saved.sample_date,
    };
  } else {
    console.log("state.prefereds", state.prefereds);

    return {
      id: null,

      product_id: state.prefereds ? state.prefereds.preferred_product_id : null,
      product_container_id: state.prefereds
        ? state.prefereds.preferred_product_container_id
        : null,

      product_container: {
        id: state.prefereds
          ? state.prefereds.preferred_product_container_id
          : null,
        price: state.prefereds ? state.prefereds.special_price : null,
        weight: state.prefereds ? state.prefereds.weight : null,
        price_per_kg: state.prefereds ? state.prefereds.price_per_kg : null,
      },

      // container_weight: 'basket_item.container_weight',
      unit_quantity: null,

      container_quantity: 1,
      container_price: null,

      container_weight: null,

      is_sample: false,
      free_product_type_id: null,

      // container_weight: 'basket_item.container_weight',
      // container_quantity: 'basket_item.container_quantity',
      // container_price: 'basket_item.container_price',

      // product_container_price: 'personal_settings.container_price',
      // product_container_price_per_kg: 'variant.price_per_kg',
      // product_container_is_sample: 'basket_item.is_sample',
      // product_container_approve_required_from_id: 'basket_item.approve_required_from_id',
      // product_container_is_approved: 'basket_item.is_approved',

      // product_name: 'product.name'

      notes: null,
      approve_comment: null,
      sample_date: null,
    };
  }
}

export const actions: ActionTree<DealProductsState, RootState> = {
  reset({ commit }) {
    commit("RESET_STATE");
  },

  loadData(
    { commit, getters, dispatch, state },
    { documentId, clientId, remains },
  ) {
    const vm = (this as any)._vm;

    state.documentId = documentId;
    state.clientId = clientId;
    state.remains = remains;

    return new Promise((resolve, reject) => {
      vm.$db([
        vm
          .$q(PL_RELAED_PRODUCTS_LIST)
          .raw("documents.list")
          .action({
            no_meta: true,
            columns: {
              id: "basket_item.id",
              container_weight: "basket_item.container_weight",
              container_quantity: "basket_item.container_quantity",
              container_price: "basket_item.container_price",
              notes: "basket_item.notes",
              sample_date: "basket_item.sample_date",
              approve_comment: "basket_item.approve_comment",
              created_at: "basket_item.created_at",
              updated_at: "basket_item.updated_at",
              product_container_id: "variant.id",
              product_container_name: "variant.name",
              product_container_price: "personal_settings.container_price",
              product_container_price_per_kg: "variant.price_per_kg",
              product_container_weight: "variant.weight",
              product_container_is_sample: "basket_item.is_sample",
              free_product_type_id: "basket_item.free_product_type_id",
              product_container_approve_required_from_id:
                "basket_item.approve_required_from_id",
              product_container_is_approved: "basket_item.is_approved",
              product_id: "product.id",
              product_name: "product.name",
            },
            from: "s:deal_product_containers",
            from_as: "basket_item",
            joins: [
              {
                join: "s:product_containers",
                type: "left",
                as: "variant",
                on: {
                  $eq: ["basket_item.product_container_id", "variant.id"],
                },
              },
              {
                join: "s:products",
                type: "left",
                as: "product",
                on: {
                  $eq: ["variant.product_id", "product.id"],
                },
              },
              {
                join: "s:client_product_containers",
                type: "left",
                as: "personal_settings",
                on: {
                  $and: [
                    {
                      $eq: [
                        "personal_settings.product_container_id",
                        "variant.id",
                      ],
                    },
                    { $eq: ["personal_settings.client_id", { $: clientId }] },
                  ],
                },
              },
            ],
            page_size: 1000,
            order: [{ $desc: ["basket_item.id"] }],
            where: {
              $eq: [`basket_item.deal_id`, { $: documentId }],
            },
          }),

        vm
          .$q(PL_PRODUCT_PREFEREDS)
          .raw("documents.list")
          .action({
            no_meta: true,
            columns: {
              preferred_product_container_id:
                "client.preferred_product_container_id",
              preferred_product_id: "variant.product_id",
              weight: "variant.weight",
              special_price: "personal_settings.container_price",
              price_per_kg: "variant.price_per_kg",
            },
            from: "s:deals",
            from_as: "deal",
            joins: [
              {
                join: "s:clients",
                type: "left",
                as: "client",
                on: {
                  $eq: ["client.id", "deal.client_id"],
                },
              },
              {
                join: "s:product_containers",
                type: "left",
                as: "variant",
                on: {
                  $eq: ["variant.id", "client.preferred_product_container_id"],
                },
              },
              {
                join: "s:client_product_containers",
                type: "left",
                as: "personal_settings",
                on: {
                  $and: [
                    {
                      $eq: [
                        "personal_settings.product_container_id",
                        "variant.id",
                      ],
                    },
                    { $eq: ["personal_settings.client_id", { $: clientId }] },
                  ],
                },
              },
            ],
            where: {
              $eq: [`deal.id`, { $: documentId }],
            },
          }),
      ]).then((result: ServerResult) => {
        // state.items = result.getOperation('QNAME').getContent().documents;
        // console.log('!!!!', this.items)

        const opRelResult = result.getOperation(PL_RELAED_PRODUCTS_LIST);
        // const opProductsResult = result.getOperation(PL_PRODUCTS_LIST);
        // const opVariantsResult = result.getOperation(PL_PRODUCT_VARIANTS_LIST);
        const opPrefereds = result.getOperation(PL_PRODUCT_PREFEREDS);

        // if (!opProductsResult.hasError()) { state.productList = opProductsResult.getContent().documents; }
        // if (!opVariantsResult.hasError()) { state.productVariantList = opVariantsResult.getContent().documents; }

        if (!opPrefereds.hasError()) {
          state.prefereds = opPrefereds.getContent().documents[0];
        }

        if (!opRelResult.hasError()) {
          state.relatedProductsList = opRelResult
            .getContent()
            .documents.map((doc: any) => {
              return getBasketItem(state, doc);
            });
          // console.log('state.relatedProductsList', state.relatedProductsList)
        }

        resolve(true);
      });
    });
  },

  addItem({ state, dispatch }) {
    state.relatedProductsList.unshift(getBasketItem(state, null));
    dispatch("changeFormValue", {
      index: 0,
      field: "container_quantity",
      newValue: "1.0",
    });
  },

  removeItem({ state }, index: number) {
    if (state.relatedProductsList[index].id) {
      state.targetForDelete.push(state.relatedProductsList[index].id);
    }

    state.relatedProductsList.splice(index, 1);
  },

  changeFormValue({ state }, { index, field, newValue }) {
    console.log({ index, field, newValue });

    if (
      [
        "container_quantity",
        "unit_quantity",
        "container_price",
        "container_weight",
      ].includes(field)
    ) {
      state.relatedProductsList[index][field] = numeral(
        newValue ? newValue.replace(",", ".") : "0.0",
      ).value();
    } else if (["sample_date"].includes(field)) {
      state.relatedProductsList[index][field] = newValue
        ? moment(newValue).format("YYYY-MM-DD")
        : null;
    } else {
      state.relatedProductsList[index][field] = newValue;
    }

    if (field === "product_container" && newValue && newValue.price_per_kg) {
      const qty =
        numeral(state.relatedProductsList[index].container_quantity).value() ||
        1;
      const w = numeral(newValue.weight).value();
      if (Number.isFinite(qty) && Number.isFinite(w)) {
        state.relatedProductsList[index].container_weight = parseFloat(
          (qty * w).toFixed(DEAL_LINE_KG_DECIMALS),
        );
      }
    }

    if (["unit_quantity"].includes(field)) {
      const unitQuantity = numeral(
        state.relatedProductsList[index].unit_quantity,
      ).value();
      const tareWeight = numeral(
        state.relatedProductsList[index].product_container &&
          state.relatedProductsList[index].product_container.weight,
      ).value();

      state.relatedProductsList[index].container_quantity =
        ceilContainersFromKg(unitQuantity, tareWeight);
    }
    if (["container_quantity"].includes(field)) {
      state.relatedProductsList[index].unit_quantity =
        // @ts-ignore
        (
          numeral(state.relatedProductsList[index].container_quantity).value() *
          state.relatedProductsList[index].product_container.weight
        ).toFixed(DEAL_LINE_KG_DECIMALS) || 1;
    }

    if (
      [
        "unit_quantity",
        "container_quantity",
        "container_weight",
        "product_container_id",
        "product_container",
        "product_id",
        "is_sample",
      ].includes(field)
    ) {
      // (
      //   (
      //     parseFloat(this.formGroupObject.get('container_quantity').value) *
      //     (price_per_kg ? parseFloat(this.formGroupObject.get('container_weight').value) : this.findWeight(this.formGroupObject.get('product_container_id').value))
      //   ) *  this.findPrice(this.formGroupObject.get('product_container_id').value)
      // ).toFixed(2)

      let totalPrice = 0;
      if (state.relatedProductsList[index].product_container) {
        totalPrice =
          state.relatedProductsList[index].product_container.price *
          numeral(state.relatedProductsList[index].container_quantity).value() *
          (state.relatedProductsList[index].product_container.price_per_kg
            ? numeral(state.relatedProductsList[index].container_weight).value()
            : state.relatedProductsList[index].product_container.weight);
      }

      console.log("totalPrice", totalPrice, state.relatedProductsList[index]);
      state.relatedProductsList[index].container_price = totalPrice;
    }
  },

  saveForm({ state, dispatch }) {
    const vm = (this as any)._vm;
    const allowedFields = [
      "id",
      "deal_id",
      "container_quantity",
      "container_weight",
      "is_sample",
      "free_product_type_id",
      "is_approved",
      "container_price",
      "product_container_id",
      "notes",
      "approve_comment",
      "sample_date",
    ];

    return new Promise((resolve, reject) => {
      const normalizedItemsData = state.relatedProductsList.map(
        (item, index) => {
          const cleanDocuemnt: any = Object.keys(item)
            .filter((key: string) => allowedFields.includes(key))
            .reduce((obj: any, key: string) => {
              obj[key] = item[key];
              return obj;
            }, {});

          cleanDocuemnt.container_price =
            parseFloat(`${item.container_price}`.replace(" ", "")) + "";
          if (
            cleanDocuemnt.container_weight != null &&
            cleanDocuemnt.container_weight !== ""
          ) {
            const cw = numeral(cleanDocuemnt.container_weight).value();
            cleanDocuemnt.container_weight = Number.isFinite(cw)
              ? cw.toFixed(DEAL_LINE_KG_DECIMALS)
              : cleanDocuemnt.container_weight;
          }
          if (cleanDocuemnt.sample_date) {
            cleanDocuemnt.sample_date = moment(
              cleanDocuemnt.sample_date,
            ).format("YYYY-MM-DD");
          }
          return cleanDocuemnt;
        },
      );

      const queries = [
        vm
          .$q(`SAVE_DEAL_BASKET`)
          .update(state.documentId, {})
          .createManyRelation(
            "deal_product_containers",
            "deal_id",
            (createRelated: any) => {
              return normalizedItemsData
                .filter((item: any) => !item.id)
                .map((item, index) => createRelated(item));
            },
          )
          .updateManyRelation(
            "deal_product_containers",
            "deal_id",
            (updateRelated: any) => {
              return normalizedItemsData
                .filter((item: any) => item.id)
                .map((item, index) => updateRelated(item));
            },
          )
          .deleteManyRelation(
            "deal_product_containers",
            "deal_id",
            (deleteRelated: any) => {
              return state.targetForDelete.map((item: any, index) =>
                deleteRelated({ id: item }),
              );
            },
          ),
      ];

      vm.$db(queries).then((result: ServerResult) => {
        const totalSaveRes = !result
          .getOperation(`SAVE_DEAL_BASKET`)
          .hasError();
        if (totalSaveRes) {
          state.targetForDelete = [];

          dispatch("loadData", {
            documentId: state.documentId,
            clientId: state.clientId,
            remains: state.remains,
          }).then(() => {
            resolve(true);
          });
        } else {
          reject();
        }
      });
    });
  },
};

export const mutations: MutationTree<DealProductsState> = {
  RESET_STATE: (state) => {
    for (const key in initState) {
      (state as any)[key] = initState[key];
    }
  },
  START_LOADING: (state) => {
    state.loaded = false;
    state.loading = true;
    state.fatalError = false;
  },
  LOADED_SUCCESS: (state) => {
    state.loaded = true;
    state.loading = false;
    state.fatalError = false;
  },
  LOADED_ERROR: (state) => {
    state.loaded = true;
    state.loading = false;
    state.fatalError = true;
  },
};

export const getters: GetterTree<DealProductsState, RootState> = {
  totals: (state: DealProductsState) => {
    return {
      sum: state.relatedProductsList.reduce((val: number, item: any) => {
        return val + (parseFloat(item.container_price) || 0);
      }, 0),
    };
  },
  remainsById: (state: DealProductsState) => {
    const _remains: any = {};
    if (state.remains) {
      state.remains.map((item: any) => {
        let quantity = parseFloat(item.quantity);
        let expected = 0;
        if (item.expected.length > 1) {
          quantity -= item.expected
            .slice(0, -1)
            .reduce((item: number, sum: number) => sum + item, 0);
          expected = item.expected
            .slice(-1)
            .reduce((item: number, sum: number) => sum + item, 0);
        }
        let availability = 0;
        if (item.availability.length > 1) {
          availability = item.availability.reduce(
            (item: number, sum: number) => sum + item,
            0,
          );
        }
        let movement = 0;
        if (item.movement.length > 1) {
          movement = item.movement.reduce(
            (item: number, sum: number) => sum + item,
            0,
          );
        }
        _remains["d:product_containers:" + item.product_container_id] = {
          quantity: quantity,
          remains:
            parseFloat(item.quantity) +
            availability -
            movement -
            item.expected.reduce((item: number, sum: number) => sum + item, 0),
          availability: availability,
          movement: movement,
          expected: expected,
        };
      });
    }
    return _remains;
  },
};

export const STORE_KEY = "$_deal_product_list";

export const store = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
